// Default values for feature flags, swap this with real feature flags when we create it
export const DEFAULT_REMOTE_CONFIG_FLAGS = {
  showScrubber: true,
  excludePreroll: true,
};
